import PropTypes from "prop-types";
import { gql } from "apollo-boost";

const FILTERS_BY_COUNTRY = gql`
  query getFilters($language: String!) {
    availableLanguages {
      id
      name
      isDefault
    }
    filtersByCountry(filter: { langcode: $language }) {
      results {
        ... on NodeFilterByCountry {
          entityLabel
          fieldServicesList {
            fieldLabel
            fieldService {
              entityLabel
              tid
            }
            fieldLink {
              path
              title
            }
          }
          fieldInformativeText
          fieldAdvancedFilters {
            ... on ParagraphOptionsServices {
              fieldGroupType
              fieldOptionsType {
                entityLabel
                tid
              }
            }
            ... on ParagraphOptionsOfficeBranchTypes {
              fieldGroupType
              fieldOptionsType {
                description
                entityLabel
                tid
              }
            }
          }
          fieldGenericLink {
            title
            path
          }
          fieldListLink {
            id
            entityLabel
            fieldMultipleLinks {
              path
              routed
              title
            }
          }
        }
      }
    }
  }
`;

// THIS QUERY GET ALL THE BRANCHES FILTERED BY COUNTRY AND TAXONOMY TERMS
const OFFICE_BRANCHES = gql`
  query officeBranches(
    $langcode: String!
    $tids: String!
    $field_coordinates_proximity: String!
  ) {
    officeBranchesQuery(
      contextualFilter: {
        langcode: $langcode
        tid: $tids
        field_coordinates_proximity: $field_coordinates_proximity
      }
    ) {
      results {
        ... on NodeOfficeBranch {
          entityLabel
          entityId
          fieldLocation
          fieldEmail
          fieldAddress
          fieldMobilePhone
          fieldPrincipalPhone
          fieldDesactivarHorario
          fieldElectricCharger
          fieldDesactivarTelefono
          fieldFeatured
          fieldOfficeBranchImage {
            alt
            url
          }
          fieldOfficeBranchType
          fieldEnableBranchAppointments
          queryFieldServices {
            entityLabel
            entityId
          }
          fieldGeographyLocationCr {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldGeographyLocationGt {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldGeographyLocationHn {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldGeographyLocationNi {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldGeographyLocationPa {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldGeographyLocationSv {
            entityId
            depthLevel
            parent {
              entityId
              parent {
                entityId
              }
            }
          }
          fieldCoordinates {
            lat
            lng
          }
          fieldSchedule {
            day
            starthours
            endhours
          }
          fieldScheduleCounter {
            day
            starthours
            endhours
          }
          fieldDisclamer
        }
      }
    }
  }
`;

const OFFICE_BRANCH_FIELDS = `
  entityLabel
  entityId
  fieldLocation
  fieldEmail
  fieldAddress
  fieldMobilePhone
  fieldPrincipalPhone
  fieldDesactivarHorario
  fieldElectricCharger
  fieldDesactivarTelefono
  fieldFeatured
  fieldOfficeBranchImage {
    alt
    url
  }
  fieldOfficeBranchType
  fieldEnableBranchAppointments
  queryFieldServices {
    entityLabel
    entityId
  }
  fieldGeographyLocationCr {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldGeographyLocationGt {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldGeographyLocationHn {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldGeographyLocationNi {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldGeographyLocationPa {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldGeographyLocationSv {
    entityId
    depthLevel
    parent {
      entityId
      parent {
        entityId
      }
    }
  }
  fieldCoordinates {
    lat
    lng
  }
  fieldSchedule {
    day
    starthours
    endhours
  }
  fieldScheduleCounter {
    day
    starthours
    endhours
  }
  fieldDisclamer
`;

const GET_BRANCH_BY_ID = gql`
  query($nid: Int!) {
    officeBranchById(nid: $nid) {
      ${OFFICE_BRANCH_FIELDS}
    }
  }
`;

const GET_BRANCH_BY_TITLE = gql`
  query($title: String!) {
    officeBranchByTitle(title: $title) {
      ${OFFICE_BRANCH_FIELDS}
    }
  }
`;
function Queries(name) {
  switch (name) {
    case "filters":
      return FILTERS_BY_COUNTRY;
    case "branches":
      return OFFICE_BRANCHES;
    case "branchByID":
      return GET_BRANCH_BY_ID;
    case "branchByTitle":
      return GET_BRANCH_BY_TITLE;
  }
}

Queries.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Queries;
